/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodecount2Inputs */

const en_entity_contactcodecount2 = /** @type {(inputs: Entity_Contactcodecount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Count`)
};

const de_entity_contactcodecount2 = /** @type {(inputs: Entity_Contactcodecount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Anzahl`)
};

/**
* | output |
* | --- |
* | "Contact Code Count" |
*
* @param {Entity_Contactcodecount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodecount2 = /** @type {((inputs?: Entity_Contactcodecount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodecount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodecount2(inputs)
	return de_entity_contactcodecount2(inputs)
});
export { entity_contactcodecount2 as "entity_contactCodeCount" }